import React from 'react';
import '../App.css';
import '../style.css';
import { Link } from 'react-router-dom';
import {useState} from 'react';
import { Thumbnail } from './WorkThumbnail';
import { ArticleMainImage } from '../articleDetailPage/ArticleMainImage';


export function BlogContent (props: {
    thumbnail?: string;
    title: string;
    description : string;
    category : string;
    date : string;
    blogPage : string;
    locked : boolean;
    /** PageActivities: 공개일 기준 28일 이내일 때 true로 전달 */
    showNewBadge?: boolean;
}) {
    const [isHovering, setIsHovering] = useState(false);

  return (
    <div className='projectContentsAll' onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
        <Link to={props.blogPage} className='project' style={{textDecoration: 'none'}} >
        <div className='blogContents'>
            <div style={{display : "flex", flexDirection : "row", justifyContent: "space-between", alignItems:"flex-start", width: "100%"}}>
                <div style={{display : "flex", flexDirection : "column",gap:"20px", flex: 1, marginRight: "24px"}}>
                    <div className='projectSubtitle'>
                        {props.category}
                    </div>
                    <div style={{display : "flex", flexDirection : "column",gap:"10px"}}>
                        <div style={{display : "flex", flexDirection : "row", gap:"8px", alignItems:"center", marginTop: "0px", flexWrap: "wrap"}}>
                        <div className="projectTitle">
                            {props.title}
                        </div>
                        {(props.showNewBadge || props.locked) && (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                            {props.showNewBadge && (
                            <div className="projectNewBadge projectNewBadgeInline"><span className="projectNewBadgeText">New</span></div>
                            )}
                            {props.locked && (
                            <div className='projectLocked'>
                                <div className='projectLockedText'>Private</div>
                            </div>
                            )}
                        </div>
                        )}
                        </div>
                        <div className='projectDescription'>
                            {props.description}
                        </div>
                        <div className='projectPeriod'>{props.date}</div>
                    </div>
                </div>
                {props.thumbnail && (
                    <div style={{width: "240px", aspectRatio: "100/66", borderRadius:"15px", overflow:"hidden", flexShrink: 0, background: 'linear-gradient(var(--color-bg-soft) 0%, var(--color-bg-mid) 100%)' }}>
                        <img className="projectThumbnail" src={props.thumbnail} style={{width: "100%", height: "100%", objectFit: "cover"}} />
                    </div>
                )}
            </div>
        </div>
        </Link>
    </div>
  
  );
}

export default BlogContent;